const normalizeCustomSortFieldOption = ([key, definition]) => {
  if (definition && typeof definition === 'object' && !Array.isArray(definition)) {
    const label = definition.label || definition.value || key;

    return {
      label,
      value: key,
      providerToken: definition.providerToken || undefined
    };
  }

  return {
    label: definition || key,
    value: key
  };
};

const normalizeCustomSortFields = (customFields) => {
  return Object.entries(customFields || {}).map(normalizeCustomSortFieldOption);
};

export default normalizeCustomSortFields;
